import { render } from "./RadarChart.vue?vue&type=template&id=5b8d63e0&scoped=true"
import script from "./RadarChart.vue?vue&type=script&lang=ts"
export * from "./RadarChart.vue?vue&type=script&lang=ts"

import "./RadarChart.vue?vue&type=style&index=0&id=5b8d63e0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5b8d63e0"

export default script